import {Presenter} from '../../../../Support/with_presenter';
import {ExportService} from '../../../../Network/ExportService';

export class ExportButtonPresenter implements Presenter {
    public status: 'idle' | 'exporting' | 'exported' = 'idle';

    constructor(
        private workoutId: number,
        private type: 'json' | 'csv' | 'tcx',
        private exportService: ExportService,
    ) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public async requestExport(): Promise<void> {
        this.status = 'exporting';
        try {
            const result = await this.exportService.forWorkoutId(this.workoutId, this.type);
            if (result.status === 'success') {
                this.status = 'exported';
                window.location.href = result.data.url;
                setTimeout(() => {
                    if (this.status === 'exported') {
                        this.status = 'idle';
                    }
                }, 2000);
            } else {
                this.status = 'idle';
            }
        } catch (e) {
            this.status = 'idle';
        }
    }
}
